<template>
  <div>    
    <div v-if="this.items?.length > 0" class="overflow-x-auto mt-4 border-gray-200 border-b border-t border-r border-l rounded-lg">
      <Table 
      :headers="headers" 
      :data="this.items" 
      :withPagination="false" 
      :isLoading="isLoading" 
      :row-key="['item_name', 'duration']"
      >
      <template #duration="{ value }">
          <span>
            {{formatDuration(value)}} 
          </span>
        </template>
      </Table>
  </div>
  <div v-else>
     <div  v-if="!isLoading" class="relative mt-4 overflow-x-auto my-2 mb-4 rounded-lg  border-gray-200 border-b border-t border-r border-l">
  <table class="min-w-full h-64 text-sm rounded-lg text-left">
        <thead class="bg-gray-50 text-gray-700">
          <tr class="text-center">
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">No</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Content Title</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Reading Duration</th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr>
            <td colspan="5" class="text-center py-8 text-gray-500">
            <div class="flex-col items-center justify-center flex-nowrap flex" style="height: 574px;">
            <svg class="w-14 h-14 text-gray-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z" />
            </svg>
            <h4 class="text-base text-gray-600 mb-0">No Data</h4>
            <p class="text-sm text-gray-500">There are no data to display</p>
          </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
  
</template>

<script>
import API from "../../plugins/http"
import Table from '@/components/form/table.vue'

  export default {
    name:"PopularItemRead",
    components:{
    Table,
  },
    props:{
      id: {
        type: Number,
        required: true
      },
      from: {
        type: String,
        required: true
      },
      to: {
        type: String,
        required: true
      }
    },
    data() {
      return{
        chartReading:{},
        ReadingSeries:[{ data: [],name:"Reading" }],
        items:[],
        isLoading:true,
        headers: [  
        { label: 'No', key: '' },
        { label: 'Content Title'},
        { label: 'Reading Duration'},
     
      ],
        duration:[],
        books:[]
      }
    },
    mounted() {
      this.actionGet()
    },
    methods: {
      actionGet() {
        API.get(`reading-durations-user/group/${this.id}?from=${this.from}&to=${this.to}`).then(response => {
          if(response.status === 200 ) {
            const res = response.data.data
            this.items = Array.isArray(res) ? res : res.items || []
         ///   this.actionDestructor()
            this.isLoading = false
          }
        })
      },
      SumDuration(items){
        let sum = 0
        items.forEach(e => {
          sum += e.duration
        })
        return sum
      
      },
      formatDuration(seconds) {
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;

      if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''} ${remainingMinutes} minute${remainingMinutes !== 1 ? 's' : ''}`;
      }
      return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
},
      RemoveDuplicate(items) {
      if (!Array.isArray(items)) {
        console.warn("RemoveDuplicate: items is not an array", items);
        return [];
      }

      const unique = [];

      items.forEach(e => {
        const alreadyExists = unique.find(d => d.item_id === e.item_id);
        if (!alreadyExists) {
          unique.push(e);
        }
      });

      return unique;
},
     
      // actionDestructor(){
      //   this.isLoading = true
      //   let items = this.RemoveDuplicate(this.items)
        
      //   items.forEach(e => {
      //     let find = this.items.filter(i => i.item_id == e.item_id)
      //     if (find) {
      //       let d = this.SumDuration(find)
      //       this.books.push({
      //         name:e.item_name,
      //         isbn:e.gtin13,
      //         duration: d,
      //         item_type:find[0].item_type,
      //       })
      //     }
      //   });
      //   this.actionBuildChart()
      // },
      formatPriceBasic(value) {
        let val = (value / 1).toFixed(0).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      formatMinutes(data) {
        let menit = parseInt(data) / 60

        if (data < 60) {
          return Math.round(data) + ' Second'
        } else if (menit > 59) {
          let hour = menit / 60
          return Math.round(hour) +' Hour'
        } else if (menit < 59){
          return Math.round(menit) + ' Minute'
        } 

      }
    },
    
  }
</script>

<style lang="scss" scoped>
</style>